import Service, {
  ServiceCreator,
  ServiceDeleter,
  ServiceReader,
  ServiceUpdater,
} from "..";
import PrivateUser from "../../dtos/user";
import { UserValidationInput } from "../../dtos/user/validation";
import UserValidationApi from "../../api/user/validation";

class UserValidationServiceReader extends ServiceReader {
  public async list(): Promise<PrivateUser[]> {
    return await new UserValidationApi().get();
  }
}

class UserValidationServiceCreator extends ServiceCreator {}

class UserValidationServiceUpdater extends ServiceUpdater {
  async validate(id: number): Promise<void> {
    return await new UserValidationApi().put(
      `${id}`,
      new UserValidationInput()
    );
  }
  async return(id: number, message: string): Promise<void> {
    return await new UserValidationApi().put(
      `${id}`,
      new UserValidationInput(message)
    );
  }
}
class UserValidationServiceDeleter extends ServiceDeleter {
  async user(id: number): Promise<void> {
    return await new UserValidationApi().delete(`${id}`);
  }
}

export default class UserValidationService extends Service {
  public get read(): UserValidationServiceReader {
    return new UserValidationServiceReader();
  }
  public get create(): UserValidationServiceCreator {
    return new UserValidationServiceCreator();
  }
  public get update(): UserValidationServiceUpdater {
    return new UserValidationServiceUpdater();
  }
  public get delete(): UserValidationServiceDeleter {
    return new UserValidationServiceDeleter();
  }
}
